import { s } from "@kosmod/pancake";

import { defineTool } from "./define";

import { MiniID, MiniTemplateID } from "../mini";
import { AnyLogicState } from "../logic/all";
import { Logic } from "../logic";

const doorToggleTool = defineTool({
  key: 'minis:door:toggle',
  state: s.o({ miniId: MiniID, logicIndex: s.num }),
})

const damageMiniTool = defineTool({
  key: 'minis:hitpoints:damage',
  state: s.o({ }),
})

export const mini = {
  place: defineTool({
    key: 'minis:place',
    state: s.o({
      placementCounter: s.num,
      rotation: s.num,

      source: s.du('type', {
        template: { miniTemplateId: MiniTemplateID },
        custom: { name: s.str, logic: s.a(Logic.Any) }
      })
    }),
  }),
  move: defineTool({
    key: 'minis:move',
    state: s.o({ miniId: MiniID }),
  }),
  delete: defineTool({
    key: 'minis:delete',
    state: s.o({ miniId: MiniID })
  })
}